import React from 'react';
import {ButtonLink} from '@homeaway/react-buttons';

const FAQs = ({
    title,
    body,
    subtitle,
    faqs,
    btnText,
    helpLink,
    backText,
    onBackClick,
}) => {
    const faqBlock = faqs.map((faq, i) => {
        if (faq.q.length > 0) {
            return (
                <p key={`faq-${i}`} className="contact__faq">
                    <a href={faq.link} target="_blank" rel="noreferrer">
                        {faq.q}
                    </a>
                </p>
            );
        }
        return null;
    });
    return (
        <div className="contact__islisted">
            <h3>{title}</h3>
            <p
                className="contact__body"
                dangerouslySetInnerHTML={{__html: body}}
            />
            <h3>{subtitle}</h3>
            <div className="contact__faqs">{faqBlock}</div>
            <a
                className="btn btn-primary contact__bt"
                aria-label="help link"
                href={helpLink}
                target="_blank"
                rel="noreferrer"
                dangerouslySetInnerHTML={{__html: btnText}}
            />
            <div className="contact__back-link">
                <ButtonLink label={backText} onClick={onBackClick} />
            </div>
        </div>
    );
};

export default FAQs;
